import { currencyFormatter, rateformatter } from './formatters';

declare global {
    interface HTMLElement {
        readonly SearchRates: SearchRates | undefined;
    }

}

if (!HTMLElement.prototype.SearchRates) {
    Object.defineProperty(HTMLElement.prototype, 'SearchRates', {
        get: function () {
            const modalId = this.getAttribute('id');
            return SearchRates.instances.get(modalId || '');
        }
    });
}

export default class SearchRates {
    static instances = new Map<string, SearchRates>();

    id: string
    formEl: HTMLFormElement
    termEls: NodeListOf<HTMLInputElement>
    rateEls: NodeListOf<HTMLInputElement>
    creditRatingEls: NodeListOf<HTMLInputElement>
    cashDownEl: HTMLInputElement | null

    disabledButtonEl: HTMLButtonElement | null
    activeButtonEl: HTMLButtonElement | null
    monthlyPaymentLabelEls: NodeListOf<HTMLElement> | null
    financeAmountLabelEl: HTMLElement | null
    rateLabelEls: NodeListOf<HTMLElement> | null
    errorLabelEl: HTMLElement | null

    private constructor(triggerElement: HTMLElement) {
        let id = triggerElement.getAttribute('id');
        if (!id) {
            triggerElement.setAttribute('id', 'search-rates-0')
            this.id = 'search-rates-0'
        }
        else {
            this.id = id
        }

        this.formEl = triggerElement as HTMLFormElement;
        this.termEls = this.formEl.querySelectorAll('[search-rates-term]')
        this.rateEls = this.formEl.querySelectorAll('[search-rates-rate]')
        this.creditRatingEls = this.formEl.querySelectorAll('[search-rates-credit]')
        this.cashDownEl = this.formEl.querySelector('[search-rates-cashdown]')

        this.disabledButtonEl = this.formEl.querySelector('[search-rates-disabled-button]')
        this.activeButtonEl = this.formEl.querySelector('[search-rates-active-button]')
        this.monthlyPaymentLabelEls = document.querySelectorAll('[search-rates-monthlypayment-label]')
        this.financeAmountLabelEl = this.formEl.querySelector('[search-rates-financeamount-label]')
        this.rateLabelEls = this.formEl.querySelectorAll('[search-rates-rate-label]')
        this.errorLabelEl = this.formEl.querySelector('[search-rates-error-label]')


        this.termEls?.forEach(trigger => {
            trigger.addEventListener('click', () => this.termChanged())
        })

        this.rateEls?.forEach(trigger => {
            trigger.addEventListener('change', () => this.rateChanged())
        })

        this.creditRatingEls?.forEach(trigger => {
            trigger.addEventListener('click', () => this.creditChanged())
        })

        this.cashDownEl?.addEventListener('change', () => this.cashDownChanged())

        this.search()
    }

    public async termChanged() {
        this.setRates('')
        await this.search()
    }

    public async rateChanged() {
        await this.search()
    }

    public async creditChanged() {
        this.setRates('')
        await this.search()
    }

    public async cashDownChanged() {
        await this.search()
    }

    public setRates(val: string) {
        this.rateLabelEls?.forEach(item => {
            if (item.tagName == 'INPUT') (item as HTMLInputElement).value = val
            else item.innerHTML = val
        })
    }

    public async search() {
        const formData = new FormData(this.formEl);
        console.log(formData)

        if (formData.has('Rate')) {
            let val = formData.get('Rate')?.toString().replaceAll('%', '')
            if (val) formData.set('Rate', val)
        }

        if (formData.get("__RequestVerificationToken") == null) {
            let token = document.querySelector('[name="__RequestVerificationToken"]') as HTMLFormElement
            formData.append("__RequestVerificationToken", token.value)
        }

        const response = await fetch('/details/citystate/vehicle?handler=Search', { method: 'POST', body: formData })
        const data = await response.json()

        if (data.isError == true) {
            if (this.disabledButtonEl) this.disabledButtonEl.style.display = 'none'
            if (this.activeButtonEl) this.activeButtonEl.style.display = ''
            if (this.errorLabelEl) this.errorLabelEl.style.display = ''
            if (this.errorLabelEl) this.errorLabelEl.innerHTML = data.failedReasons

            if (this.financeAmountLabelEl) this.financeAmountLabelEl.innerHTML = ''
            if (this.monthlyPaymentLabelEls) this.monthlyPaymentLabelEls.forEach(item => item.innerHTML = '')
            this.setRates('')
        }
        else {
            if (this.errorLabelEl) this.errorLabelEl.style.display = 'none'
            if (this.financeAmountLabelEl) this.financeAmountLabelEl.innerHTML = currencyFormatter.format(data.financeAmount)
            if (this.monthlyPaymentLabelEls) this.monthlyPaymentLabelEls.forEach(item => item.innerHTML = currencyFormatter.format(data.monthlyPayment))
            if (this.rateLabelEls) {
                let val = rateformatter.format(data.rate) + ' %'
                this.setRates(val)
            }
            if (this.disabledButtonEl) this.disabledButtonEl.style.display = 'none'
            if (this.activeButtonEl) this.activeButtonEl.style.display = ''

            if (data.failedReasons && this.errorLabelEl) {
                this.errorLabelEl.style.display = ''
                this.errorLabelEl.innerHTML = data.failedReasons.join("<br>");
            }

            //if (data.tradeEquity > 0 || data.tradeEquity < 0) {
            //    $("#trade-equity-section").show()
            //    $("#trade-equity").html(formatter.format(data.tradeEquity))

            //    if (data.tradeEquity < 0) {
            //        $("#trade-equity").css("color", "rgb(255, 68, 88)")
            //    }
            //    else if (data.tradeEquity > 0) {
            //        $("#trade-equity").css("color", "#6dbd44")
            //    }
            //}
            //else {
            //    $("#trade-equity-section").hide()
            //    $("#trade-equity").html("")
            //}

            // Update Product Costs
            //$.each(data.dealershipProducts, function (i, obj) {
            //    $("#ProductCost-" + obj.id).html(formatter.format(obj.monthlyPayment))
            //})

            this.updateTermSliders(data.maxTerm)
        }
    }

    private updateTermSliders(maxTerm: number) {
        const termElsArray = Array.from(this.termEls);  // Convert NodeList to Array
        const checkedCheckbox = termElsArray.find(checkbox => checkbox.checked);

        if (checkedCheckbox) {
            let currentTerm = parseInt(checkedCheckbox.value);

            this.toggleTerm(84, maxTerm);
            this.toggleTerm(72, maxTerm);
            this.toggleTerm(60, maxTerm);

            if (currentTerm > maxTerm) {
                let checkboxToCheck = null;

                if (maxTerm >= 36 && maxTerm <= 47) {
                    checkboxToCheck = termElsArray.find(el => el.value === "36");
                } else if (maxTerm >= 48 && maxTerm <= 59) {
                    checkboxToCheck = termElsArray.find(el => el.value === "48");
                } else if (maxTerm >= 60 && maxTerm <= 71) {
                    checkboxToCheck = termElsArray.find(el => el.value === "60");
                } else if (maxTerm >= 72 && maxTerm <= 83) {
                    checkboxToCheck = termElsArray.find(el => el.value === "72");
                } else if (maxTerm >= 84) {
                    checkboxToCheck = termElsArray.find(el => el.value === "84");
                }

                if (checkboxToCheck) {
                    checkboxToCheck.checked = true;
                }
            }
        }
    }

    private toggleTerm(value:number, maxTerm:number) {
        const termElsArray = Array.from(this.termEls);  // Convert NodeList to Array

        const checkbox = termElsArray.find(el => el.value === value.toString()); // Find checkbox by value
        if (checkbox) {
            if (maxTerm < value) {
                checkbox.disabled = true;
                checkbox.closest(".radio-btn-group")?.classList.add("bg-gray-2");
            } else {
                checkbox.disabled = false;
                checkbox.closest(".radio-btn-group")?.classList.remove("bg-gray-2");
            }
        }
    }

    static getInstance(triggerElement: HTMLElement): SearchRates {
        const id = triggerElement.getAttribute('id') ?? '';
        let instance = SearchRates.instances.get(id);

        if (!instance) {
            instance = new SearchRates(triggerElement);
            SearchRates.instances.set(id, instance);
        }

        return instance;
    }
}

// Instantiation based on the HTML element with the `data-modal-trigger` attribute
document.querySelectorAll('[search-rates]').forEach(triggerElement => {
    SearchRates.getInstance(triggerElement as HTMLElement);
});